import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Constants, ToolsConstant } from '../../shared/models/constants';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { EditableTypes } from '../../shared/widgets/data-grid/enums/editable-types.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class MasterTrackerGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;

    constructor() { }

    dateCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], Constants.DATETIME_FORMAT, 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2DecimalAndCurrency(rowData: any, field: any) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<div class="text-truncate" title="`
                + parseFloat(value.toFixed(2)).toLocaleString() + `">` + parseFloat(value.toFixed(2)).toLocaleString() + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    savingsCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    }

    editedCellRenderer(rowData: any, field: any) {
        let isUpdated = false;
        let originalData = '';
        const displayValue = rowData[field];
        if (rowData[field] !== undefined && rowData[field] !== null) {
            switch (field) {
                case 'subprojectNameOnCertificate':
                    isUpdated = rowData.isSubprojectNameOnCertificateUpdated;
                    originalData = rowData.originalSubprojectNameOnCertificate;
                    break;
                case 'noOfBuildings':
                    isUpdated = rowData.isNoOfBuildingsUpdated;
                    originalData = rowData.originalNoOfBuildings;
                    break;
                case 'ownerCompany':
                    isUpdated = rowData.isOwnerCompanyUpdated;
                    originalData = rowData.originalOwnerCompany;
                    break;
                case 'ifcClient':
                    isUpdated = rowData.isIFCClientUpdated;
                    originalData = rowData.originalIFCClient;
                    break;               
                case 'holdingCompanyInvestor':
                    isUpdated = rowData.isHoldingCompanyInvestorUpdated;
                    originalData = rowData.originalHoldingCompanyInvestor;
                    break;
                case 'clientCount':
                    isUpdated = rowData.isClientCountUpdated;
                    originalData = rowData.originalClientCount;
                    break;
                case 'project_SiteCount':
                    isUpdated = rowData.isProject_SiteCountUpdated;
                    originalData = rowData.originalProject_SiteCount;
                    break;
                case 'preliminaryEnergySavingsPerYear':
                    isUpdated = rowData.isPreliminaryEnergySavingsPerYearUpdated;
                    originalData = rowData.originalPreliminaryEnergySavingsPerYear;
                    break;
                case 'preliminaryWaterSavingsPerYear':
                    isUpdated = rowData.isPreliminaryWaterSavingsPerYearUpdated;
                    originalData = rowData.originalPreliminaryWaterSavingsPerYear;
                    break;
                case 'preliminaryEmbodiedEnergyInMaterialsSavings':
                    isUpdated = rowData.isPreliminaryEmbodiedEnergyInMaterialsSavingsUpdated;
                    originalData = rowData.originalPreliminaryEmbodiedEnergyInMaterialsSavings;
                    break;
                case 'preliminaryEmbodiedCarbonInMaterialsSavings':
                    isUpdated = rowData.isPreliminaryEmbodiedCarbonInMaterialsSavingsUpdated;
                    originalData = rowData.originalPreliminaryCarbonInMaterialsSavings;
                    break;
                case 'preliminaryCO2SavingsPerYear':
                    isUpdated = rowData.isPreliminaryCO2SavingsPerYearUpdated;
                    originalData = rowData.originalPreliminaryCO2SavingsPerYear;
                    break;
                case 'preliminaryFloorSpaceCertified':
                    isUpdated = rowData.isPreliminaryFloorSpaceCertifiedUpdated;
                    originalData = rowData.originalPreliminaryFloorSpaceCertified;
                    break;
                case 'postEnergySavingsPerYear':
                    isUpdated = rowData.isPostEnergySavingsPerYearUpdated;
                    originalData = rowData.originalPostEnergySavingsPerYear;
                    break;
                case 'postWaterSavingsPerYear':
                    isUpdated = rowData.isPostWaterSavingsPerYearUpdated;
                    originalData = rowData.originalPostWaterSavingsPerYear;
                    break;
                case 'postEmbodiedCarbonInMaterialsSavings':
                    isUpdated = rowData.isPostEmbodiedCarbonInMaterialsSavingsUpdated;
                    originalData = rowData.originalPostEmbodiedCarbonInMaterialsSavings;
                    break;
                case 'postEmbodiedEnergyInMaterialsSavings':
                    isUpdated = rowData.isPostEmbodiedEnergyInMaterialsSavingsUpdated;
                    originalData = rowData.originalPostEmbodiedEnergyInMaterialsSavings;
                    break;
                case 'postCO2SavingsPerYear':
                    isUpdated = rowData.isPostCO2SavingsPerYearUpdated;
                    originalData = rowData.originalPostCO2SavingsPerYear;
                    break;
                case 'postFloorSpaceCertified':
                    isUpdated = rowData.isPostFloorSpaceCertifiedUpdated;
                    originalData = rowData.originalPostFloorSpaceCertified;
                    break;
                case 'prelimProjectEmissionBalanceZC':
                    isUpdated = rowData.isPrelimProjectEmissionBalanceUpdated;
                    originalData = rowData.prelimProjectEmissionBalance;
                    break;
                case 'prelimActualProjectEmissionZC':
                    isUpdated = rowData.isPrelimActualProjectEmissionUpdated;
                    originalData = rowData.prelimActualProjectEmission;
                    break;
                case 'prelimProjectEmissionOffsetZC':
                    isUpdated = rowData.isPrelimProjectEmissionOffsetUpdated;
                    originalData = rowData.prelimProjectEmissionOffset;
                    break;
                case 'prelimActualEnergyPerformanceIndexZC':
                    isUpdated = rowData.isPrelimActualEnergyPerformanceIndexUpdated;
                    originalData = rowData.prelimActualEnergyPerformanceIndex;
                    break;
                case 'prelimActualEnergyFromRenewablesZC':
                    isUpdated = rowData.isPrelimActualEnergyFromRenewablesUpdated;
                    originalData = rowData.prelimActualEnergyFromRenewables;
                    break;
                case 'postProjectEmissionBalanceZC':
                    isUpdated = rowData.isPostProjectEmissionBalanceUpdated;
                    originalData = rowData.postProjectEmissionBalance;
                    break;
                case 'postActualProjectEmissionZC':
                    isUpdated = rowData.isPostActualProjectEmissionUpdated;
                    originalData = rowData.postActualProjectEmission;
                    break;
                case 'postProjectEmissionOffsetZC':
                    isUpdated = rowData.isPostProjectEmissionOffsetUpdated;
                    originalData = rowData.postProjectEmissionOffset;
                    break;
                case 'postActualEnergyPerformanceIndexZC':
                    isUpdated = rowData.isPostActualEnergyPerformanceIndexUpdated;
                    originalData = rowData.postActualEnergyPerformanceIndex;
                    break;
                case 'postActualEnergyFromRenewablesZC':
                    isUpdated = rowData.isPostActualEnergyFromRenewablesUpdated;
                    originalData = rowData.postActualEnergyFromRenewables;
                    break;
                default:
                    isUpdated = false;
                    break;
            }

            if (isUpdated) {
                if (originalData == null) {
                    originalData = `'No Value'`;
                }
                return `<span class="text-edgeblue" title="Original Value : ${originalData}">${displayValue}</span>`;
            } else {
                return `<span title=${displayValue}>${displayValue}<span>`;
            }
        } else {
            return '';
        }
    }

    dropUndropRenderer(rowData, field) {
        if (!rowData.finalCertifyDate) {
            if (rowData.isSubprojectDropped === null || !rowData.isSubprojectDropped) {
                return `<span title="Drop Subproject">Drop</span>`;
            } else if (rowData.isSubprojectDropped) {
                return `<span title="Undrop Subproject">Undrop</span>`;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    subprojectNameCellRenderer(rowData: any) {
        return rowData.projectType === 'Offline' ?
        `<span class="grid-cell-notification me-1"><i class="fas fa-circle grey-muted"></i></span>
        ${rowData.subprojectName}` : rowData.subprojectName;
    }

    getColumnCA(clients: any): Array<TableColumn> {
        // TODO:- Need to move these columns to constant and dashboard grid service.
        const countSelect: Array<any> = [{ value: 0, label: '0' }, { value: 1, label: '1' }];       
        return [        
            {
                field: 'subprojectName',
                header: 'Subproject Name',
                pinned: true,
                sort: true,
                sortName: 'SubprojectName',
                filter: { type: FilterTypes.text },
                style: { 'width': '250px', 'min-width': '250px', 'max-width': '250px' },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.subprojectNameCellRenderer
                }
            },
            {
                field: 'projectName',
                header: 'Project Name',
                pinned: false,
                sort: true,
                sortName: 'ProjectName',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'latestComment',
                header: 'Comments'                
            },
            {
                field: 'toolName',
                header: 'Building Type',
                sort: true,
                sortName: 'ToolName'
            },
            {
                field: 'buildingSubtype',
                header: 'Building Sub Type',
                sort: true,
                sortName: 'BuildingSubtype',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'country',
                header: 'Country',
                sort: true,
                sortName: 'Country'
            },
            {
                field: 'city',
                header: 'City',
                sort: true,
                sortName: 'City',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'typeofConstruction',
                header: 'Type of Construction',
                sort: true,
                sortName: 'TypeofConstruction'
            },
            {
                field: 'shareWithInvestor',
                header: 'Share with Bank(s)',
                sort: false
            },
            {
                field: 'projectTrainingPurpose',
                header: 'Training Purpose',
                sort: false
            },
            {
                field: 'ownerCompany',
                header: 'Client Name',
                sort: true,
                sortName: 'OwnerCompany',
                filter: { type: FilterTypes.text },
                editable: { type: EditableTypes.text, maxlength: 150 },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'incomeCategory',
                header: 'Income Category',
                sort: true,
                sortName: 'IncomeCategory',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'preliminaryCertificateNumber',
                header: 'Preliminary Certificate Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'projectCertificateNumber',
                header: 'Project Certificate Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'preliminaryCertificateNumberZC',
                header: 'Preliminary ZC Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryCertificateNumberZC'
            },
            {
                field: 'finalCertificateNumber',
                header: 'Final Certificate Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'finalCertificateNumberZC',
                header: 'Final ZC Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalCertificateNumberZC'
            },
            {
                field: 'subprojectNameOnCertificate',
                header: 'Subproject Name on Certificate',
                sort: true,
                sortName: 'subprojectNameOnCertificate',
                filter: { type: FilterTypes.text },               
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'projectStatus',
                header: 'Project Status',
                sort: false
            },
            {
                field: 'zeroCarbonStatus',
                header: 'Zero Carbon Status',
                filter: { type: FilterTypes.select, selectOptions: ToolsConstant.zeroCarbonCertificationStatus },
                sort: true,
                sortName: 'ZeroCarbonStatus'
            },
            {
                field: 'certifier',
                header: 'Certifier',
                sort: true,
                sortName: 'Certifier'
            },
            {
                field: 'preliminaryZeroCarbonCertifier',
                header: 'Preliminary ZC Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonCertifier'
            },
            {
                field: 'finalZeroCarbonCertifier',
                header: 'Final ZC Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonCertifier'
            },
            {
                field: 'auditor',
                header: 'Auditor'
            },
            {
                field: 'reviewer',
                header: 'Reviewer'
            },
            {
                field: 'preliminaryZeroCarbonReviewer',
                header: 'Preliminary ZC Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonReviewer'
            },
            {
                field: 'finalZeroCarbonReviewer',
                header: 'Final ZC Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonReviewer'
            },
            {
                field: 'sentForRegistrationDate',
                header: 'Sent for Registration',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'sentForAuditDate',
                header: 'Sent for Audit',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'sentForReviewDate',
                header: 'Sent for Review',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyDate',
                header: 'Preliminary Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyDate',
                header: 'Final Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryReviewCompletionDateZC',
                header: 'Preliminary ZC Review Decision Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyDateZC',
                header: 'Preliminary ZC Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalReviewCompletionDateZC',
                header: 'Final ZC Review Decision Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyDateZC',
                header: 'Final ZC Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'certificationStage',
                header: 'Certification Stage',
                sort: true,
                sortName: 'CertificationStage'
            },
            {
                field: 'registrationDate',
                header: 'Registration Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'registrationFiscalYear',
                header: 'FY of Registration',
                sort: true,
                sortName: 'registrationFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfRegistrationFiscalYear',
                header: 'FY Half of Registration',
                sort: true,
                sortName: 'HalfRegistrationFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'sentForCertifiedDate',
                header: 'Preliminary Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertificateIssuedDateZC',
                header: 'Preliminary ZC Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyFiscalYear',
                header: 'FY of Preliminary Certification',
                sort: true,
                sortName: 'PreliminaryCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfPreliminaryCertifyFiscalYear',
                header: 'FY Half of Preliminary Certification',
                sort: true,
                sortName: 'HalfPreliminaryCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'sentForPostCertifiedDate',
                header: 'Final Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertificateIssuedDateZC',
                header: 'Final ZC Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyFiscalYear',
                header: 'FY of EDGE Certification',
                sort: true,
                sortName: 'FinalCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfFinalCertifyFiscalYear',
                header: 'FY Half of EDGE Certification',
                sort: true,
                sortName: 'halfFinalCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'daysRegistered',
                header: 'Days Registered'
            },
            {
                field: 'preliminaryNoOfUnits',
                header: 'Homes - No. of Units (Preliminary)'
            },
            {
              field: 'finalNoOfUnits',
              header: 'Homes - No. of Units (Final)'
            },
            {
                field: 'noOfBuildings',
                header: 'No. of Buildings',               
            },
            {
                field: 'peopleImpacted',
                header:'No. of People Impacted',
                sort: false,
            },
            {
                field: 'atleastNoOfUnit',
                header: 'At-Least Prelim No. of Units (Homes)',
                sort: false,
            },
            {
                field: 'atLeastPreliminaryCertificateDate',
                header: 'At-Least Prelim Cert Date',
                sort: false,
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'atLeastPreliminaryCertifyFiscalYear',
                header: 'FY of At-Least Prelim Cert Date',
                sort: false,
            },
            {
                field: 'atLeastHalfPreliminaryCertifyFiscalYear',
                header: 'FY Half of At-Least Prelim Cert Date',
                sort: false,
            },
            {
                field: 'certificatesIssuedForPreliminary',
                header: 'No. of Preliminary Certificates issued'
            },
            {
                field: 'certificatesIssuedForFinal',
                header: 'No. of Final Certificates issued'
            },
            {
                field: 'projectNumber',
                header: 'Project Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'fileNumber',
                header: 'File Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'priorityCountry',
                header: 'Priority Country',
                filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'Priority', value: 'Priority' },
                        { label: 'Other', value: 'Other' }
                    ]
                }
            },
            {
                field: 'asopCountry',
                header: 'ASOP Country',
                filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'ASOP', value: 'ASOP' },
                        { label: 'Other', value: 'Other' }
                    ]
                }
            },           
            {
                field: 'ifcClient',
                header: 'Origination Tag',
                sort: true,
                sortName: 'IfcClient',
                filter: { type: FilterTypes.text },
                editable: { type: EditableTypes.select, selectOptions: clients },
                cellRenderer: { type: CellRendererTypes.html, renderHtml: this.editedCellRenderer }
            },
            {
                field: 'referringEntity',
                header: 'Referring Entity',
            },
            {
                field: 'holdingCompanyInvestor',
                header: 'Holding Company/Investor/Bank',               
            },
            {
                field: 'clientCount',
                header: 'Client Count',               
            },
            {
                field: 'project_SiteCount',
                header: 'Project Count',               
            },
            {
                field: 'energy',
                header: 'Energy',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'water',
                header: 'Water',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'material',
                header: 'Material',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'preliminaryEnergySavingsPerYear',
                header: 'Preliminary Energy Savings (MWh/Year)',                
            },
            {
                field: 'preliminaryWaterSavingsPerYear',
                header: 'Preliminary Water Savings (m³/Year)',               
            },
            {
                field: 'preliminaryEmbodiedEnergyInMaterialsSavings',
                header: 'Preliminary Embodied Energy in Materials Savings (GJ)',
            },
            {
                field: 'preliminaryEmbodiedCarbonInMaterialsSavings',
                header: 'Preliminary Embodied Carbon in Materials Savings (tCO₂e)',
            },
            {
                field: 'preliminaryCarbonEmissions',
                header: 'Preliminary Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'preliminaryCO2SavingsPerYear',
                header: 'Preliminary CO₂ Savings (tCO₂/Year)',               
            },
            {
                field: 'preUtilityCostSavings',
                header: 'Preliminary Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'preIncrementalCost',
                header: 'Preliminary Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'prePaybackInYears',
                header: 'Preliminary Payback in Years'
            },
            {
                field: 'preliminaryFloorSpaceCertified',
                header: 'Preliminary Total Subproject Area (m²)',               
            },
            {
                field: 'prelimZeroCarbonPeriod',
                header: 'Preliminary ZC Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PrelimZeroCarbonPeriod'
            },
            {
                field: 'prelimProjectEmissionBalanceZC',
                header: 'Preliminary Project Emission Balance (tCO₂ equivalent)'
            },
            {
                field: 'prelimActualProjectEmissionZC',
                header: 'Preliminary Actual Project Emission (tCO₂e)'
            },
            {
                field: 'prelimProjectEmissionOffsetZC',
                header: 'Preliminary Project Emission Offset (tCO₂e)'
            },
            {
                field: 'prelimActualEnergyPerformanceIndexZC',
                header: 'Preliminary Actual Energy Performance Index (kWh/m²)'
            },
            {
                field: 'prelimActualEnergyFromRenewablesZC',
                header: 'Preliminary Actual Energy From Renewables (%)'
            },
            {
                field: 'postEnergySavingsPerYear',
                header: 'Post-Construction Energy Savings (MWh/Year)',                
            },
            {
                field: 'postWaterSavingsPerYear',
                header: 'Post-Construction Water Savings (m³/Year)',                
            },
            {
                field: 'postEmbodiedEnergyInMaterialsSavings',
                header: 'Post-Construction Embodied Energy in Materials Savings (GJ)',
            },
            {
                field: 'postEmbodiedCarbonInMaterialsSavings',
                header: 'Post-Construction Embodied Carbon in Materials Savings (tCO₂e)',
            },
            {
                field: 'postCarbonEmissions',
                header: 'Post-Construction Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'postCO2SavingsPerYear',
                header: 'Post-Construction CO₂ Savings (tCO₂/Year)',               
            },
            {
                field: 'postUtilityCostSavings',
                header: 'Post-Construction Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'postIncrementalCost',
                header: 'Post-Construction Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'postPaybackInYears',
                header: 'Post-Construction Payback in Years'
            },
            {
                field: 'postFloorSpaceCertified',
                header: 'Post-Construction Total Subproject Area (m²)',                
            },
            {
                field: 'postZeroCarbonPeriod',
                header: 'Final ZC Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PostZeroCarbonPeriod'
            },
            {
                field: 'postProjectEmissionBalanceZC',
                header: 'Post-Construction Project Emission Balance (tCO₂ equivalent)'
            },
            {
                field: 'postActualProjectEmissionZC',
                header: 'Post-Construction Actual Project Emission (tCO₂e)'
            },
            {
                field: 'postProjectEmissionOffsetZC',
                header: 'Post-Construction Project Emission Offset (tCO₂e)'
            },
            {
                field: 'postActualEnergyPerformanceIndexZC',
                header: 'Post-Construction Actual Energy Performance Index (kWh/m²)'
            },
            {
                field: 'postActualEnergyFromRenewablesZC',
                header: 'Post-Construction Actual Energy From Renewables (%)'
            },
            {
                field: 'effectiveDate',
                header: 'Effective Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'effEnergySavings',
                header: 'Effective Energy Savings (MWh/Year)'
            },
            {
                field: 'effWaterSavings',
                header: 'Effective Water Savings (m³/Year)'
            },
            {
                field: 'effEmbodiedEnergyInMaterialsSavings',
                header: 'Effective Embodied Energy in Materials Savings (GJ)'
            },
            {
                field: 'effEmbodiedCarbonInMaterialsSavings',
                header: 'Effective Embodied Carbon in Materials Savings (tCO₂e)'
            },
            {
                field: 'effCO2Savings',
                header: 'Effective CO₂ Savings (tCO₂/Year)'
            },
            {
                field: 'effFloorSpaceCertified',
                header: 'Effective Total Subproject Area (m²)'
            },
            {
                field: 'effCarbonEmissions',
                header: 'Effective Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'effNoOfUnits',
                header: 'Effective No. of Units (Homes)'
            },
            {
                field: 'currency',
                header: 'Units for Utility Cost Savings'
            },
            {
                field: 'projectType',
                header: 'Project Type'
            },
            {
                field: 'subprojectDroppedDate',
                header: 'Dropped Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'subprojectDroppedFiscalYear',
                header: 'FY of Subproject Dropped',
                sort: true,
                sortName: 'SubprojectDroppedFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfSubprojectDroppedFiscalYear',
                header: 'FY Half of Subproject Dropped',
                sort: true,
                sortName: 'halfSubprojectDroppedFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'lastActivity',
                header: 'Last Activity',
                sort: true,
                sortName: 'lastActivity',
                filter: { type: FilterTypes.calender },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                },
            },
            {
                field: 'preIncrementalCostMetric',
                header: 'Preliminary Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'preUtilityCostSavingsMetric',
                header: 'Preliminary Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'postIncrementalCostMetric',
                header: 'Post-Construction Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'postUtilityCostSavingsMetric',
                header: 'Post-Construction Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'atleastPreIncrementalCostMetric',
                header: 'At-Least Preliminary Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'atleastPreUtilityCostSavingsMetric',
                header: 'At-Least Preliminary Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },

            {
                field: 'version',
                header: 'Version',
            },
            {
                field: 'currencyConversionFactor',
                header: 'Currency Conversion Factor (Currency/USD)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveUtilityCostSavingsinUSD',
                header: 'Effective Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveUtilityCostSavingsMetric',
                header: 'Effective Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },

            {
                field: 'effectiveIncrementalCostinUSD',
                header: 'Effective Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveIncrementalCost',
                header: 'Effective Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'dateOfExpiryPreZC',
                header: 'Preliminary ZC Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'dateOfExpiryFinalZC',
                header: 'Final ZC Certificate Expiry Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'dateOfExpiryPreZCR',
                header: 'Preliminary ZC Renewal Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'dateOfExpiryFinalZCR',
                header: 'Final ZC Renewal Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertifier',
                header: 'Preliminary ZCR Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalCertifier'
            },

            {
                field: 'finalZeroCarbonRenewalCertifier',
                header: 'Final ZCR Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalCertifier'
            },
            {
                field: 'preliminaryZeroCarbonRenewalReviewer',
                header: 'Preliminary ZCR Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalReviewer'
            },

            {
                field: 'finalZeroCarbonRenewalReviewer',
                header: 'Final ZCR Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalReviewer'
            },
            {
                field: 'preliminaryZeroCarbonRenewalReviewCompletionDate',
                header: 'Preliminary ZCR Review Decision Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificationDate',
                header: 'Preliminary ZCR Certification Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificateIssuedDate',
                header: 'Preliminary ZCR Certificate Issued Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalReviewCompletionDate',
                header: 'Final ZCR Review Decision Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalCertificationDate',
                header: 'Final ZCR Certification Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalCertificateIssuedDate',
                header: 'Final ZCR Certificate Issued Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalPeriod',
                header: 'Preliminary ZCR Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalPeriod'
            },
            {
                field: 'finalZeroCarbonRenewalPeriod',
                header: 'Final ZCR Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalPeriod'
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificateNumber',
                header: 'Preliminary ZCR Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalCertificateNumber'
            },
            {
                field: 'finalZeroCarbonRenewalCertificateNumber',
                header: 'Final ZCR Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalCertificateNumber'
            }

            
            //{
            //    field: 'isSubprojectDropped',
            //    header: 'Drop/Undrop',
            //    cellRenderer: {
            //        type: CellRendererTypes.eventHtml,
            //        elementType: CellRendererElementTypes.anchor,
            //        eventName: 'onDropUndropClick',
            //        renderHtml: this.dropUndropRenderer
            //    }
            //}
        ];
    }

    getColumn(clients: any): Array<TableColumn> {
        // TODO:- Need to move these columns to constant and dashboard grid service.
        const countSelect: Array<any> = [{ value: 0, label: '0' }, { value: 1, label: '1' }];       
        return [
            {
                field: '',
                header: 'Checkbox',
                pinned: true,
                columnCheckBox: true,
                style: { 'width': '40px', 'min-width': '40px', 'max-width': '40px' },
                sort: false
            },
            {
                field: 'subprojectName',
                header: 'Subproject Name',
                pinned: true,
                sort: true,
                sortName: 'SubprojectName',
                filter: { type: FilterTypes.text },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.subprojectNameCellRenderer
                }
            },
            {
                field: 'projectName',
                header: 'Project Name',
                pinned: false,
                sort: true,
                sortName: 'ProjectName',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'latestComment',
                header: 'Comments',
                cellRenderer: {
                    type: CellRendererTypes.event,
                    elementType: CellRendererElementTypes.comment,
                    eventName: 'onCommentClick'
                }
            },
            {
                field: 'toolName',
                header: 'Building Type',
                sort: true,
                sortName: 'ToolName'
            },
            {
                field: 'buildingSubtype',
                header: 'Building Sub Type',
                sort: true,
                sortName: 'BuildingSubtype',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'country',
                header: 'Country',
                sort: true,
                sortName: 'Country'
            },
            {
                field: 'city',
                header: 'City',
                sort: true,
                sortName: 'City',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'typeofConstruction',
                header: 'Subproject Type',
                sort: true,
                sortName: 'TypeofConstruction'
            },
            {
                field: 'shareWithInvestor',
                header: 'Share with Bank(s)',
                sort: false
            },
            {
                field: 'projectTrainingPurpose',
                header: 'Training Purpose',
                sort: false
            },
            {
                field: 'ownerCompany',
                header: 'Client Name',
                sort: true,
                sortName: 'OwnerCompany',
                filter: { type: FilterTypes.text },
                editable: { type: EditableTypes.text, maxlength: 150 },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'incomeCategory',
                header: 'Income Category',
                sort: true,
                sortName: 'IncomeCategory',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'preliminaryCertificateNumber',
                header: 'Preliminary Certificate Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'preliminaryCertificateNumberZC',
                header: 'Preliminary ZC Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryCertificateNumberZC'
            },
            {
                field: 'finalCertificateNumber',
                header: 'Final Certificate Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'finalCertificateNumberZC',
                header: 'Final ZC Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalCertificateNumberZC'
            },
            {
                field: 'subprojectNameOnCertificate',
                header: 'Subproject Name on Certificate',
                sort: true,
                sortName: 'subprojectNameOnCertificate',
                filter: { type: FilterTypes.text },
                editable: { type: EditableTypes.text, maxlength: 150 },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'projectStatus',
                header: 'Project Status',
                sort: false
            },
            {
                field: 'zeroCarbonStatus',
                header: 'Zero Carbon Status',
                filter: { type: FilterTypes.select, selectOptions: ToolsConstant.zeroCarbonCertificationStatus },
                sort: true,
                sortName: 'ZeroCarbonStatus'
            },
            {
                field: 'certifier',
                header: 'Certifier',
                sort: true,
                sortName: 'Certifier'
            },
            {
                field: 'preliminaryZeroCarbonCertifier',
                header: 'Preliminary ZC Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonCertifier'
            },
            {
                field: 'finalZeroCarbonCertifier',
                header: 'Final ZC Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonCertifier'
            },
            {
                field: 'auditor',
                header: 'Auditor'
            },
            {
                field: 'reviewer',
                header: 'Reviewer'
            },
            {
                field: 'preliminaryZeroCarbonReviewer',
                header: 'Preliminary ZC Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonReviewer'
            },
            {
                field: 'finalZeroCarbonReviewer',
                header: 'Final ZC Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonReviewer'
            },
            {
                field: 'sentForRegistrationDate',
                header: 'Sent for Registration',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'sentForAuditDate',
                header: 'Sent for Audit',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'sentForReviewDate',
                header: 'Sent for Review',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyDate',
                header: 'Preliminary Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyDate',
                header: 'Final Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryReviewCompletionDateZC',
                header: 'Preliminary ZC Review Decision Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyDateZC',
                header: 'Preliminary ZC Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalReviewCompletionDateZC',
                header: 'Final ZC Review Decision Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyDateZC',
                header: 'Final ZC Certification Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'certificationStage',
                header: 'Certification Stage',
                sort: true,
                sortName: 'CertificationStage'
            },
            {
                field: 'registrationDate',
                header: 'Registration Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'registrationFiscalYear',
                header: 'FY of Registration',
                sort: true,
                sortName: 'registrationFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfRegistrationFiscalYear',
                header: 'FY Half of Registration',
                sort: true,
                sortName: 'HalfRegistrationFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'sentForCertifiedDate',
                header: 'Preliminary Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertificateIssuedDateZC',
                header: 'Preliminary ZC Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryCertifyFiscalYear',
                header: 'FY of Preliminary Certification',
                sort: true,
                sortName: 'PreliminaryCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfPreliminaryCertifyFiscalYear',
                header: 'FY Half of Preliminary Certification',
                sort: true,
                sortName: 'HalfPreliminaryCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'sentForPostCertifiedDate',
                header: 'Final Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertificateIssuedDateZC',
                header: 'Final ZC Certificate Issued Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalCertifyFiscalYear',
                header: 'FY of EDGE Certification',
                sort: true,
                sortName: 'FinalCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfFinalCertifyFiscalYear',
                header: 'FY Half of EDGE Certification',
                sort: true,
                sortName: 'halfFinalCertifyFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'daysRegistered',
                header: 'Days Registered'
            },
            {
                field: 'preliminaryNoOfUnits',
                header: 'Homes - No. of Units (Preliminary)'
            },
            {
              field: 'finalNoOfUnits',
              header: 'Homes - No. of Units (Final)'
            },
            {
                field: 'noOfBuildings',
                header: 'No. of Buildings',
                editable: { type: EditableTypes.number, maxlength: 5 },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'peopleImpacted',
                header:'No. of People Impacted',
                sort: false,
            },
            {
                field: 'atleastNoOfUnit',
                header: 'At-Least Prelim No. of Units (Homes)',
                sort: false,
            },
            {
                field: 'atLeastPreliminaryCertificateDate',
                header: 'At-Least Prelim Cert Date',
                sort: false,
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'atLeastPreliminaryCertifyFiscalYear',
                header: 'FY of At-Least Prelim Cert Date',
                sort: false,
            },
            {
                field: 'atLeastHalfPreliminaryCertifyFiscalYear',
                header: 'FY Half of At-Least Prelim Cert Date',
                sort: false,
            },
            {
                field: 'certificatesIssuedForPreliminary',
                header: 'No. of Preliminary Certificates issued'
            },
            {
                field: 'certificatesIssuedForFinal',
                header: 'No. of Final Certificates issued'
            },
            {
                field: 'projectNumber',
                header: 'Project Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'fileNumber',
                header: 'File Number',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'priorityCountry',
                header: 'Priority Country',
                filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'Priority', value: 'Priority' },
                        { label: 'Other', value: 'Other' }
                    ]
                }
            },
            {
                field: 'asopCountry',
                header: 'ASOP Country',
                filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'ASOP', value: 'ASOP' },
                        { label: 'Other', value: 'Other' }
                    ]
                }
            },
            {
                field: 'magcCountry',
                header: 'MAGC Country',
                filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'MAGC', value: 'MAGC' },
                        { label: 'Other', value: 'Other' }
                    ]
                }
            },           
            {
                field: 'referringEntity',
                header: 'Referring Entity',
            },
            {
                field: 'ifcClient',
                header: 'Origination Tag',
                sort: true,
                sortName: 'IfcClient',
                filter: { type: FilterTypes.text },
                editable: { type: EditableTypes.select, selectOptions: clients },
                cellRenderer: { type: CellRendererTypes.html, renderHtml: this.editedCellRenderer }
            },
            {
                field: 'holdingCompanyInvestor',
                header: 'Holding Company/Investor/Bank',
                editable: { type: EditableTypes.text, maxlength: 150 },
                cellRenderer: { type: CellRendererTypes.html, renderHtml: this.editedCellRenderer }
            },
            {
                field: 'clientCount',
                header: 'Client Count',
                editable: { type: EditableTypes.select, selectOptions: countSelect },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'project_SiteCount',
                header: 'Project Count',
                editable: { type: EditableTypes.select, selectOptions: countSelect },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                }
            },
            {
                field: 'energy',
                header: 'Energy',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'water',
                header: 'Water',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'material',
                header: 'Material',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.savingsCellRenderer
                }
            },
            {
                field: 'preliminaryEnergySavingsPerYear',
                header: 'Preliminary Energy Savings (MWh/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'preliminaryWaterSavingsPerYear',
                header: 'Preliminary Water Savings (m³/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'preliminaryEmbodiedEnergyInMaterialsSavings',
                header: 'Preliminary Embodied Energy in Materials Savings (GJ)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            }, {
                field: 'preliminaryEmbodiedCarbonInMaterialsSavings',
                header: 'Preliminary Embodied Carbon in Materials Savings (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'preliminaryCarbonEmissions',
                header: 'Preliminary Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'preliminaryCO2SavingsPerYear',
                header: 'Preliminary CO₂ Savings (tCO₂/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'preUtilityCostSavings',
                header: 'Preliminary Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'preIncrementalCost',
                header: 'Preliminary Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'prePaybackInYears',
                header: 'Preliminary Payback in Years'
            },
            {
                field: 'preliminaryFloorSpaceCertified',
                header: 'Preliminary Total Subproject Area (m²)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'prelimZeroCarbonPeriod',
                header: 'Preliminary ZC Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PrelimZeroCarbonPeriod'
            },
            {
                field: 'prelimProjectEmissionBalanceZC',
                header: 'Preliminary Project Emission Balance (tCO₂ equivalent)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'prelimActualProjectEmissionZC',
                header: 'Preliminary Actual Project Emission (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'prelimProjectEmissionOffsetZC',
                header: 'Preliminary Project Emission Offset (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'prelimActualEnergyPerformanceIndexZC',
                header: 'Preliminary Actual Energy Performance Index (kWh/m²)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'prelimActualEnergyFromRenewablesZC',
                header: 'Preliminary Actual Energy From Renewables (%)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Preliminary' }
                }
            },
            {
                field: 'postEnergySavingsPerYear',
                header: 'Post-Construction Energy Savings (MWh/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postWaterSavingsPerYear',
                header: 'Post-Construction Water Savings (m³/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postEmbodiedEnergyInMaterialsSavings',
                header: 'Post-Construction Embodied Energy in Materials Savings (GJ)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postEmbodiedCarbonInMaterialsSavings',
                header: 'Post-Construction Embodied Carbon in Materials Savings (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postCarbonEmissions',
                header: 'Post-Construction Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'postCO2SavingsPerYear',
                header: 'Post-Construction CO₂ Savings (tCO₂/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postUtilityCostSavings',
                header: 'Post-Construction Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'postIncrementalCost',
                header: 'Post-Construction Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency
                }
            },
            {
                field: 'postPaybackInYears',
                header: 'Post-Construction Payback in Years'
            },
            {
                field: 'postFloorSpaceCertified',
                header: 'Post-Construction Total Subproject Area (m²)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postZeroCarbonPeriod',
                header: 'Final ZC Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PostZeroCarbonPeriod'
            },
            {
                field: 'postProjectEmissionBalanceZC',
                header: 'Post-Construction Project Emission Balance (tCO₂ equivalent)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postActualProjectEmissionZC',
                header: 'Post-Construction Actual Project Emission (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postProjectEmissionOffsetZC',
                header: 'Post-Construction Project Emission Offset (tCO₂e)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postActualEnergyPerformanceIndexZC',
                header: 'Post-Construction Actual Energy Performance Index (kWh/m²)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'postActualEnergyFromRenewablesZC',
                header: 'Post-Construction Actual Energy From Renewables (%)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.editedCellRenderer
                },
                editable: {
                    type: EditableTypes.decimal,
                    maxlength: 20,
                    conditional: { field: 'certificationStage', value: 'Final' }
                }
            },
            {
                field: 'effectiveDate',
                header: 'Effective Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'effEnergySavings',
                header: 'Effective Energy Savings (MWh/Year)'
            },
            {
                field: 'effWaterSavings',
                header: 'Effective Water Savings (m³/Year)'
            },
            {
                field: 'effEmbodiedEnergyInMaterialsSavings',
                header: 'Effective Embodied Energy in Materials Savings (GJ)'
            },
            {
                field: 'effEmbodiedCarbonInMaterialsSavings',
                header: 'Effective Embodied Carbon in Materials Savings (tCO₂e)'
            },
            {
                field: 'effCO2Savings',
                header: 'Effective CO₂ Savings (tCO₂/Year)'
            },
            {
                field: 'effFloorSpaceCertified',
                header: 'Effective Total Subproject Area (m²)'
            },
            {
                field: 'effCarbonEmissions',
                header: 'Effective Carbon Emissions (tCO₂/Year)'
            },
            {
                field: 'effNoOfUnits',
                header: 'Effective No. of Units (Homes)'
            },
            {
                field: 'currency',
                header: 'Units for Utility Cost Savings'
            },
            {
                field: 'projectType',
                header: 'Project Type'
            },
            {
                field: 'subprojectDroppedDate',
                header: 'Dropped Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'subprojectDroppedFiscalYear',
                header: 'FY of Subproject Dropped',
                sort: true,
                sortName: 'SubprojectDroppedFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'halfSubprojectDroppedFiscalYear',
                header: 'FY Half of Subproject Dropped',
                sort: true,
                sortName: 'halfSubprojectDroppedFiscalYear',
                filter: { type: FilterTypes.text }
            },
            {
                field: 'lastActivity',
                header: 'Last Activity',
                sort: true,
                sortName: 'lastActivity',
                filter: { type: FilterTypes.calender },
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },

            {
                field: 'isSubprojectDropped',
                header: 'Drop/Undrop',
                cellRenderer: {
                    type: CellRendererTypes.eventHtml,
                    elementType: CellRendererElementTypes.anchor,
                    eventName: 'onDropUndropClick',
                    renderHtml: this.dropUndropRenderer
                }
            },
            {
                field: 'preIncrementalCostMetric',
                header: 'Preliminary Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'preUtilityCostSavingsMetric',
                header: 'Preliminary Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'postIncrementalCostMetric',
                header: 'Post-Construction Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'postUtilityCostSavingsMetric',
                header: 'Post-Construction Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'atleastPreIncrementalCostMetric',
                header: 'At-Least Preliminary Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'atleastPreUtilityCostSavingsMetric',
                header: 'At-Least Preliminary Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },

            {
                field: 'version',
                header: 'Version',
            },
            {
                field: 'currencyConversionFactor',
                header: 'Currency Conversion Factor (Currency/USD)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveUtilityCostSavingsinUSD',
                header: 'Effective Utility Cost Savings in USD/year',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveUtilityCostSavingsMetric',
                header: 'Effective Utility Cost Savings Metric (Currency/Year)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
         
            {
                field: 'effectiveIncrementalCostinUSD',
                header: 'Effective Incremental Cost in USD',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'effectiveIncrementalCost',
                header: 'Effective Incremental Cost (Currency)',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.fixedTo2DecimalAndCurrency

                }
            },
            {
                field: 'dateOfExpiryPreZC',
                header: 'Preliminary ZC Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'dateOfExpiryFinalZC',
                header: 'Final ZC Certificate Expiry Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },

            {
                field: 'preliminaryZeroCarbonRenewalCertifier',
                header: 'Preliminary ZCR Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalCertifier'
            },

            {
                field: 'finalZeroCarbonRenewalCertifier',
                header: 'Final ZCR Certifier',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalCertifier'
            },
            {
                field: 'preliminaryZeroCarbonRenewalReviewer',
                header: 'Preliminary ZCR Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalReviewer'
            },

            {
                field: 'finalZeroCarbonRenewalReviewer',
                header: 'Final ZCR Reviewer',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalReviewer'
            },
            {
                field: 'preliminaryZeroCarbonRenewalReviewCompletionDate',
                header: 'Preliminary ZCR Review Decision Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificationDate',
                header: 'Preliminary ZCR Certification Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificateIssuedDate',
                header: 'Preliminary ZCR Certificate Issued Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalReviewCompletionDate',
                header: 'Final ZCR Review Decision Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalCertificationDate',
                header: 'Final ZCR Certification Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'finalZeroCarbonRenewalCertificateIssuedDate',
                header: 'Final ZCR Certificate Issued Date',

                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'preliminaryZeroCarbonRenewalPeriod',
                header: 'Preliminary ZCR Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalPeriod'
            },
            {
                field: 'finalZeroCarbonRenewalPeriod',
                header: 'Final ZCR Period',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalPeriod'
            },
            {
                field: 'preliminaryZeroCarbonRenewalCertificateNumber',
                header: 'Preliminary ZCR Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'PreliminaryZeroCarbonRenewalCertificateNumber'
            },
            {
                field: 'finalZeroCarbonRenewalCertificateNumber',
                header: 'Final ZCR Certificate Number',
                filter: { type: FilterTypes.text },
                sort: true,
                sortName: 'FinalZeroCarbonRenewalCertificateNumber'
            },
             {
                field: 'dateOfExpiryPreZCR',
                header: 'Preliminary ZC Renewal Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'dateOfExpiryFinalZCR',
                header: 'Final ZC Renewal Certificate Expiry Date',
                cellRenderer: {
                    type: CellRendererTypes.html,
                    renderHtml: this.dateCellRenderer
                }
            },
            {
                field: 'clientWorkflowDays',
                header: 'Client Workflow Days'
            },
            {
                field: 'auditorWorkflowDays',
                header: 'Auditor Workflow Days'
            },
            {
                field: 'reviewerWorkflowDays',
                header: 'Reviewer Workflow Days'
            },
            {
                field: 'certifierWorkflowDays',
                header: 'Certifier Workflow Days'
            }
        ];
    }
}

